The conflict result for the `postPositionFromDraft` mutation.
